import type { FC } from 'react';
import { Flex } from '@chakra-ui/react';
import { useIntl } from 'react-intl';
import { useCustomerGeoLocationStore } from '../../../bff-api/stores/useCustomerGeoLocationStore';
import { Email } from '../email';
import { FindUs } from '../find-us';
import {
    StackedAboutLinks,
    StackedCustomerServiceLinks,
    StackedExperienceLinks,
} from '../link-groups';
import { Social } from '../social';
import { FooterStore } from '../store/FooterStore';

export const FooterDesktop: FC = () => {
    const { data } = useCustomerGeoLocationStore();
    const intl = useIntl();

    return (
        <div data-testid="footer-desktop-container" className="flex h-full w-full justify-between">
            <StackedExperienceLinks />
            <StackedCustomerServiceLinks />
            <StackedAboutLinks />
            <Flex direction="column" gap={5}>
                <FooterStore
                    id="footer"
                    store={data}
                    title={intl
                        .formatMessage({
                            id: 'nearest.store',
                            defaultMessage: 'Nearest Store',
                        })
                        .toUpperCase()}
                />
                <FindUs />
            </Flex>
            <div className="flex max-w-[352px] flex-1 flex-col gap-8 ">
                <Email />
                <Social />
            </div>
        </div>
    );
};
